<script>
  import options from './SourceReferences.options'
  export default options
</script>

<template>
  <article class="kb-source-references">

    <h2 class="kb-source-references__title">
      {{ getLabel('title') }}:
    </h2>

    <div class="kb-source-references__results">
       <div v-for="(reference, index) in references" :key="index">
          <a :href="reference.url" class="kb-source-references__result-link">
            {{ reference.name }}
            <svg width="17" height="9" viewBox="0 0 17 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.1674 0.370606L15.7899 4.37061L12.1674 8.37061" stroke="#E8001D" stroke-linejoin="round"/>
              <path d="M11.7465 4.37061H0" stroke="#E8001D"/>
            </svg>
          </a>
       </div>
    </div>

    <template v-if="totalHits !== null">
      <p>{{ showingLabel }}</p>
    </template>

    <template v-if="showLoadMore">
      <button class="kb-button" v-on:click="fetchReferences">
        {{ getLabel('showMore') }}
      </button>
    </template>

    <template v-if="isLoading">
      <div class="kb-spinner-overlay">
        <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
      </div>
    </template>

</article>
</template>
